import { Psbt } from "bitcoinjs-lib";
import { Interface, TransactionRequest } from "ethers";
import { Account } from "../accounts";
import { InsufficientAllowanceError } from "../errors";
import { BaseMsg, Msg } from "./msg";

export class MsgErc20IncreaseAllowance extends BaseMsg implements Msg {
  constructor(
    public account: Account,
    private error: InsufficientAllowanceError
  ) {
    super();
  }
  async toEvmTxRequest(): Promise<{ tx: TransactionRequest }> {
    const iface = new Interface([
      "function approve(address spender, uint256 addedValue) public returns (bool)",
    ]);

    const data = iface.encodeFunctionData("approve", [
      this.error.spender,
      this.error.required,
    ]);

    return {
      tx: {
        to: this.error.asset.contract,
        from: this.account.address,
        data,
      },
    };
  }
  toPsbt(): Promise<{
    psbt: Psbt;
    fee: bigint;
    amount: bigint;
    memo: string;
    recipient: string;
  }> {
    throw new Error("toPsbt not implemented for MsgErc20IncreaseAllowance.");
  }
}
